import type { Transition, Variants } from 'framer-motion';
import type { CSSProperties } from 'react';
import { Colors } from '~/themes/colors';

export const Animations = {
  Popover: {
    transition: { duration: 0.1 } as Transition,
    variants: {
      show: { opacity: 1, display: 'flex' },
      hide: { opacity: 0, transitionEnd: { display: 'none' } },
    } as Variants,
  },
};

export const Styles = {
  Popover: {
    backgroundColor: Colors.neutral_150,
    borderRadius: 10,
    boxShadow: '0px 6px 10px 2px rgba(0, 0, 0, 0.15), 0px 2px 3px 0px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 400,
    minHeight: 220,
    overflow: 'auto',
    padding: '10px 0px',
    position: 'absolute',
    top: '8%',
    whiteSpace: 'nowrap',
    width: '100%',
    zIndex: 4,
  } as CSSProperties,
  ScrollArea: {
    paddingInline: 12,
    paddingTop: 10,
    width: 'auto',
  } as CSSProperties,
  Trigger: {
    alignItems: 'center',
    backgroundColor: Colors.neutral_50,
    border: 'none',
    borderRadius: 10,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25) inset',
    cursor: 'pointer',
    display: 'flex',
    height: 40,
    justifyContent: 'space-between',
    paddingInline: 16,
    width: '100%',
  } as CSSProperties,
};
